/* global window */
import { Box, Heading2, StackView } from 'localmed-core';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../../shared/components/DiComponents';
import SchedulingTimeSelectionCalendar from '../../../../components/SchedulingTimeSelectionCalendar';
import SelectedReasonForVisit from '../../../../components/SelectedReasonForVisit';
import { shouldSkipReasonSelectionScreen } from '../../utils';
import BackLink from '../BackLink';
import { hasSelectedNewProvider, IStepProps } from '../schedulingWizard';
import { BackButton, CaptionText, ContentWrapper, Wrapper } from '../styles';

interface Props extends IStepProps {}

export default function SchedulingTimeSelectionStep({ wizard }: Props) {
  useEffect(() => {
    if (wizard?.trackSchedulingEvent) {
      wizard.trackSchedulingEvent(
        'Scheduling Time selection Screen',
        'SchedulingTimeSelectionStep'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!wizard) return null;

  const { values } = wizard;
  const { submitErrors } = wizard.form.getState();

  function goBack() {
    if (wizard == null) return;

    if (values.showProviderSelection || !shouldSkipReasonSelectionScreen(wizard)) {
      wizard.gotoPreviousStep();
    } else {
      wizard.gotoStep(0);
    }
  }
  return (
    <Wrapper>
      <BackLink onClick={goBack} />
      <ContentWrapper>
        <Box textAlign={{ _: 'center', lg: 'left' }} width="100%">
          <StackView spacing="xl">
            {values.scheduleRequest == null && <SelectedReasonForVisit wizard={wizard} />}
            <StackView spacing="lg" width="100%">
              <Heading2>
                <FormattedMessage
                  id="scheduling.SchedulingTimeSelectionStep.title"
                  defaultMessage="{newProvider, select, true {Looks like you selected a new provider. We need you to choose a new appointment time. } false {}}When would you like to come in?"
                  values={{
                    newProvider: hasSelectedNewProvider(values),
                  }}
                />
              </Heading2>

              <CaptionText mt="md">
                <FormattedMessage
                  id="scheduling.SchedulingTimeSelectionStep.calendarCaption"
                  defaultMessage="Select the day and time that you want to schedule your appointment."
                />
              </CaptionText>
              <SchedulingTimeSelectionCalendar
                values={values}
                hasOpeningUnavailableError={!!submitErrors?.opening}
                setValue={wizard?.form.change}
              />
            </StackView>
          </StackView>
        </Box>
      </ContentWrapper>
      <Box display="flex" justifyContent={{ _: 'center', lg: 'space-between' }}>
        <BackButton
          onClick={goBack}
          display={{ _: 'none', lg: 'inherit' }}
          variant="subtle"
          size="xl"
        >
          <FormattedMessage
            id="scheduling.SchedulingTimeSelectionStep.backButton"
            defaultMessage="Back"
          />
        </BackButton>
        <DiButton {...wizard.nextButtonProps} size="xl">
          <FormattedMessage
            id="scheduling.SchedulingTimeSelectionStep.nextButton"
            defaultMessage="Next"
          />
        </DiButton>
      </Box>
    </Wrapper>
  );
}

SchedulingTimeSelectionStep.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  id: 'SCHEDULING_TIME_SELECTION_STEP',
};
